import React from "react";
import { Check, X } from "lucide-react";

const rows = [
  { k: "Time to close", agent: "60–90 days", us: "As fast as 7 days" },
  { k: "Commissions / fees", agent: "Up to 6% of sale price", us: "$0 — we pay closing costs" },
  { k: "Repairs required", agent: "Often required", us: "Never — buy as-is" },
  { k: "Showings & open houses", agent: "Multiple over weeks", us: "None" },
  { k: "Financing risk", agent: "Buyer may back out", us: "Guaranteed cash" },
  { k: "Appraisal contingencies", agent: "Yes", us: "None" },
];

export default function Benefits() {
  return (
    <section
      id="benefits"
      data-testid="benefits"
      className="border-b border-[var(--c4p-line)] bg-[var(--c4p-cream)] py-20 lg:py-28"
    >
      <div className="mx-auto grid max-w-7xl grid-cols-1 gap-14 px-6 lg:grid-cols-12 lg:gap-16 lg:px-10">
        <div className="lg:col-span-5">
          <span className="eyebrow">Why sell to us</span>
          <h2 className="font-display mt-4 text-[40px] leading-[1.02] sm:text-[52px] lg:text-[60px]">
            The difference is in the{" "}
            <span className="font-display-italic text-[var(--c4p-orange)]">details.</span>
          </h2>
          <p className="mt-6 max-w-md font-sans-ui text-[15px] leading-relaxed text-[var(--c4p-muted)]">
            Listing with an agent can take months — and cost you tens of
            thousands in fees and repairs. Here's how selling to Cash 4
            Properties actually compares.
          </p>

          <div className="mt-8 overflow-hidden rounded-2xl border border-[var(--c4p-line)]">
            <img
              src="https://images.pexels.com/photos/6077554/pexels-photo-6077554.jpeg"
              alt="Handshake between buyer and seller"
              className="h-64 w-full object-cover"
              loading="lazy"
            />
          </div>
        </div>

        <div className="lg:col-span-7">
          <div className="rounded-2xl border border-[var(--c4p-line)] bg-white p-2 shadow-[0_30px_60px_-40px_rgba(12,59,46,.2)]">
            <table data-testid="compare-table" className="cmp-table w-full">
              <thead>
                <tr>
                  <th className="text-left">What matters</th>
                  <th className="text-left">Traditional Agent</th>
                  <th className="text-left">Cash 4 Properties</th>
                </tr>
              </thead>
              <tbody>
                {rows.map((r, i) => (
                  <tr key={i}>
                    <td className="font-sans-ui text-[15px] font-semibold text-[var(--c4p-ink)]">{r.k}</td>
                    <td className="cmp-no flex items-start gap-2 font-sans-ui text-[14px]">
                      <X size={14} className="mt-1 shrink-0" />
                      {r.agent}
                    </td>
                    <td className="cmp-yes font-sans-ui text-[14px]">
                      <span className="inline-flex items-start gap-2">
                        <Check size={14} className="mt-1 shrink-0" />
                        {r.us}
                      </span>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          <p className="mt-4 font-sans-ui text-[12px] text-[var(--c4p-muted)]">
            * Typical outcome. Your specific situation may vary — we'll give
            you a straight answer either way.
          </p>
        </div>
      </div>
    </section>
  );
}
